export { EditContactModal } from "./edit-contact-modal";
